import { createStyles, keyframes } from '@mantine/core';

const rollIn = keyframes({
  from: { opacity: 0, transform: 'translateY(100%)' },
  to: { opacity: 1, transform: 'translateY(0)' },
});

const rollOut = keyframes({
  from: { opacity: 1, transform: 'translateY(0)' },
  to: { opacity: 0, transform: 'translateY(-100%)' },
});

const DURATION = '0.28s';
const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

export const useStyles = createStyles(() => ({
  root: {
    display: 'inline-grid',
    overflow: 'hidden',
    justifyItems: 'center',
    verticalAlign: 'bottom',

    '& > *': {
      gridArea: '1 / 1',
    },
  },

  enter: {
    animation: `${rollIn} ${DURATION} ${EASING}`,

    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
    },
  },

  exit: {
    animation: `${rollOut} ${DURATION} ${EASING} forwards`,

    '@media (prefers-reduced-motion: reduce)': {
      animation: 'none',
      opacity: 0,
    },
  },
}));
